import React from "react";
import { Button } from "@/shared/components/ui/Button";
import Strings from "@/shared/utils/Strings.constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

interface SavedPaymentMethodProps {
    cardType?: string;
    lastFour?: string;
    onSubmit?: () => void;
    isQuoteUpdating: boolean;
}

export function SavedPaymentMethod({ cardType, lastFour, onSubmit, isQuoteUpdating }: SavedPaymentMethodProps) {
    return (
        <>
            {cardType && lastFour && (
                <div className="flex w-full justify-between rounded-xl border-2 border-stroke-brand-b px-4 py-3 disabled:opacity-100">
                    <span className="text-sm font-medium text-content-secondary">Pay with</span>
                    <span className="text-sm text-content-primary">
                        <span className="font-bold">{cardType}</span> &#8226;&#8226;&#8226;&#8226; {lastFour}
                    </span>
                </div>
            )}
            <Button
                variant="default-rounded"
                className="w-full px-4 py-5"
                disabled={isQuoteUpdating}
                loading={isQuoteUpdating}
                onClick={() => onSubmit?.()}
                endDecorator={<FontAwesomeIcon icon={faChevronRight} className="size-4" />}
            >
                {Strings.COMPLETE_CHECKOUT}
            </Button>
        </>
    );
}
